const alertTypes = {
  SET_ALERT: 'ALERT_SET',
  REMOVE_ALERT: 'ALERT_REMOVE',
};
export default alertTypes;
